import classnames from 'classnames';
import React from 'react';
import { BsFillEyeSlashFill } from 'react-icons/bs';
import { useHistory } from 'react-router';
import styles from './ghostButton.module.scss';

interface GhostButtonProps {
  // eslint-disable-next-line @typescript-eslint/ban-types
  ghostUser: Function;
}

const GhostButton = ({ ghostUser }: GhostButtonProps) => {
  const history = useHistory();
  return (
    <button
      className={classnames(styles.btn, 'border-0 bg-transparent')}
      onClick={() => {
        ghostUser();
        history.push('/all-users');
      }}
    >
      <BsFillEyeSlashFill className={classnames('text-primary', styles.icon)} />
    </button>
  );
};

export default GhostButton;
